@if (hasExistingParties()) {
  <div class="flex-container vertical-align">
    <mat-form-field class="flex-item-3" appearance="outline">
      <mat-select [placeholder]="'common.labels.reusableParty' | transloco" [(ngModel)]="this.selectedExistingPartyID">
        @for (party of existingParties; track party; let i = $index) {
          <mat-option [value]="party.id!"
            [attr.data-testid]="'existing-party-option-' + i">
            {{ getDisplayName(party) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-raised-button (click)="saveExistingParty()" [disabled]="selectedExistingPartyID == ''" color="primary"
      class="wrap-button flex-item" [attr.aria-label]="'handleExistingParty.saveReusablePartyButton' | transloco"
      data-testid="add-reusable-party-button">
      {{ buttonText }}
    </button>
  </div>
}